import {ActionTypes} from '../actions/toast_index'

const initialState = {kind: null, nonce: null}

export default function toastReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SHOW_TOAST:
      return {kind: action.payload.kind, nonce: action.payload.nonce}

    case ActionTypes.HIDE_TOAST:
      return {kind: null, nonce: null}

    default:
      return state
  }
}
